/* Folliva Clear 2026-10-15 (Oliver, like IM8): the Free Starter Kit gifts reach checkout as their own lines
   (€15 struck → Free through the automatic "Free Starter Kit" discount), while the cart keeps showing only
   the kit row under the plan.
   - Checkout (drawer button, cart page button, quiz): the gifts the cart qualifies for go in, extras come out,
     then checkout opens. Checkout is never blocked: on any error, or after 4 s, it opens as it is.
   - Gifts go in through the Storefront API cart (cartLinesAdd). Unlike /cart/add.js, the browser pixels
     (Meta, Whop) do not report that as an add to cart (checked 2026-10-15).
   - After a cart change and on page load, gifts the cart no longer qualifies for come out again.
   - The header count copies the drawer's count (gift lines are not counted there).
   Settings: Cart drawer → Free Starter Kit gifts at checkout. cart-drawer and main-cart hide the gift lines. */
(function () {
  "use strict";
  var el = document.querySelector("script[data-fc-kit-gifts]");
  if (!el || window.FCKit) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  var sp = Number(cfg.sp) || 0;
  var gifts = (cfg.gifts || []).filter(function (g) { return g && g.v && g.p; }).map(function (g) {
    return { v: Number(g.v), p: Number(g.p), sizes: (g.sizes || []).map(function (s) { return String(s).trim().toLowerCase(); }).filter(Boolean) };
  });
  if (!sp || !gifts.length) return;

  function isGift(it) { for (var i = 0; i < gifts.length; i++) { if (gifts[i].p === it.product_id) return true; } return false; }
  /* the gifts (variant ids) this cart qualifies for: a plan line of a listed size */
  function wanted(cart) {
    var want = {};
    cart.items.forEach(function (it) {
      if (it.product_id !== sp) return;
      var size = String(it.variant_title || "").trim().toLowerCase();
      gifts.forEach(function (g) { if (g.sizes.indexOf(size) > -1) want[g.v] = true; });
    });
    return want;
  }
  function json(r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); }
  function getCart() { return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } }).then(json); }
  function change(key, qty) {
    if (window.FL && FL.cart && FL.cart.change) return FL.cart.change(key, qty);
    return fetch("/cart/change.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) }).then(json);
  }
  function sfAdd(token, ids) {
    var q = "mutation($id: ID!, $l: [CartLineInput!]!) { cartLinesAdd(cartId: $id, lines: $l) { userErrors { message } } }";
    var lines = ids.map(function (v) { return { merchandiseId: "gid://shopify/ProductVariant/" + v, quantity: 1 }; });
    return fetch("/api/" + (cfg.api || "2026-07") + "/graphql.json", {
      method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ query: q, variables: { id: "gid://shopify/Cart/" + token, l: lines } })
    }).then(json).then(function (j) {
      var res = j && j.data && j.data.cartLinesAdd;
      if (!res || (res.userErrors && res.userErrors.length)) throw new Error("Free Starter Kit: gifts not added " + JSON.stringify(j).slice(0, 200));
    });
  }
  /* gifts the cart no longer qualifies for, and second copies, come out; a gift's quantity stays 1 */
  function trim(cart, want) {
    var seen = {}, jobs = [];
    cart.items.forEach(function (it) {
      if (!isGift(it)) return;
      if (!want[it.variant_id] || seen[it.variant_id]) jobs.push([it.key, 0]);
      else { seen[it.variant_id] = true; if (it.quantity !== 1) jobs.push([it.key, 1]); }
    });
    return jobs.reduce(function (p, j) { return p.then(function () { return change(j[0], j[1]); }); }, Promise.resolve()).then(function () { return seen; });
  }
  var busy = false;
  function ensure() {
    busy = true;
    return getCart().then(function (cart) {
      var want = wanted(cart);
      return trim(cart, want).then(function (have) {
        var add = Object.keys(want).filter(function (v) { return !have[v]; });
        if (add.length) return sfAdd(cart.token, add);
      });
    }).then(function () { busy = false; }, function (e) { busy = false; throw e; });
  }
  function settle(p, ms) {
    return new Promise(function (done) {
      var t = setTimeout(done, ms);
      p.then(function () { clearTimeout(t); done(); }, function (e) { clearTimeout(t); if (window.console) console.warn(e); done(); });
    });
  }
  function cleanup() {
    if (busy) return;
    busy = true;
    getCart().then(function (cart) { return trim(cart, wanted(cart)); }).catch(function () {}).then(function () { busy = false; });
  }
  function syncHeaderCount() {
    var d = document.querySelector("[data-fl-cart-section] [data-fl-cart-count]");
    var n = d ? parseInt(d.textContent, 10) : NaN;
    if (isNaN(n)) return;
    document.querySelectorAll(".fl-header__cart-count[data-fl-cart-count]").forEach(function (h) {
      h.textContent = n;
      if (n > 0) h.removeAttribute("hidden"); else h.setAttribute("hidden", "");
    });
  }
  var FCKit = window.FCKit = { beforeCheckout: function () { return settle(ensure(), 4000); } };

  /* drawer button and other links to checkout */
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest('a[data-fl-checkout], a[href="/checkout"], a[href="/cart/checkout"]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    if (a.getAttribute("aria-busy") === "true") return;
    a.setAttribute("aria-busy", "true"); a.classList.add("is-loading");
    FCKit.beforeCheckout().then(function () { window.location.href = a.href; });
  });
  /* cart page: the form's checkout button */
  document.addEventListener("submit", function (e) {
    var f = e.target, b = e.submitter;
    if (!f || f.__fcKit || !b || b.name !== "checkout") return;
    e.preventDefault();
    b.disabled = true; b.classList.add("is-loading");
    FCKit.beforeCheckout().then(function () {
      f.__fcKit = true;
      var h = document.createElement("input"); h.type = "hidden"; h.name = "checkout"; h.value = b.value || "1"; f.appendChild(h);
      HTMLFormElement.prototype.submit.call(f);
    });
  });
  /* back from checkout with a different cart: take out what no longer applies */
  document.addEventListener("fl:cart:updated", function () { cleanup(); syncHeaderCount(); });
  window.addEventListener("pageshow", function (e) {
    if (!e.persisted) return;
    document.querySelectorAll("a[data-fl-checkout][aria-busy]").forEach(function (a) { a.removeAttribute("aria-busy"); a.classList.remove("is-loading"); });
    cleanup();
  });
  syncHeaderCount();
  if (Number(cfg.n) > 0) cleanup();
})();
